import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  VStack,
  Text,
  Radio,
  RadioGroup,
  Stack,
  Box,
  IconButton,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";

// Predefined reasons for reporting a question
const REPORT_REASONS = [
  "Question incohérente ou incompréhensible",
  "Question hors sujet",
  "Question trop générale ou vague",
  "Question incorrecte sur le plan technique"
];

const ReportQuestionModal = ({ isOpen, onClose, onSubmit }) => {
  const [selectedReason, setSelectedReason] = useState("");

  // Clear selected reason whenever the modal is closed / reopened
  useEffect(() => {
    if (!isOpen) {
      setSelectedReason("");
    }
  }, [isOpen]);

  const handleSubmit = () => {
    if (!selectedReason) return;
    onSubmit(selectedReason);
    onClose(); // Close modal immediately after submitting
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="black" fontSize="lg">
          Signaler la question
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={4} align="stretch">
            <Text fontSize="sm" color="gray.700">
              Veuillez sélectionner une raison :
            </Text>
            
            <RadioGroup value={selectedReason} onChange={setSelectedReason}>
              <Stack spacing={1}>
                {REPORT_REASONS.map((reason) => (
                  <Box 
                    key={reason} 
                    p={2} 
                    borderWidth="1px" 
                    borderRadius="md" 
                    cursor="pointer" 
                    _hover={{ bg: "gray.50" }}
                    onClick={() => setSelectedReason(reason)}
                  >
                    <Radio value={reason} colorScheme="purple" pointerEvents="none">
                      <Text fontSize="sm" ml={2} mt="12px">
                        {reason}
                      </Text>
                    </Radio>
                  </Box>
                ))}
              </Stack>
            </RadioGroup>
            
            <Button
              bg="rgb(37, 87, 167)"
              color="white"
              _hover={{ bg: "rgb(27, 67, 137)" }}
              _active={{ bg: "rgb(17, 47, 107)" }}
              onClick={handleSubmit}
              isDisabled={!selectedReason}
              mt={4}
            >
              Envoyer
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ReportQuestionModal; 